import React from 'react';
import { Paper } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

const QuotaManagementToggle = ({ section, view, handleChangeView, toggleButtonStyle }) => {
  return (
    <Paper>
      <ToggleButtonGroup
        value={view}
        exclusive
        onChange={handleChangeView}
        aria-label="management-view"
      >
        <ToggleButton value="add" aria-label="add" style={toggleButtonStyle('add')}>
          Add {section} Quota
        </ToggleButton>
        <ToggleButton value="remove" aria-label="remove" style={toggleButtonStyle('remove')}>
          Delete {section} Quota
        </ToggleButton>
        <ToggleButton value="update" aria-label="update" style={toggleButtonStyle('update')}>
          Update {section} Quota
        </ToggleButton>
      </ToggleButtonGroup>
    </Paper>
  );
};

export default QuotaManagementToggle;
